export enum KEYBOARD_KEYS {
    BACKSPACE = 'Backspace',
}

export const MAX_LENGTH_OF_INPUT = 1;
